module.exports = __webpack_public_path__ + "img/img3c.21c47827.png";